import React, { useCallback } from 'react';
import { setRetentionViewAction } from '../../../redux/slices/oldBuilder';
import {
  QueryType,
  RetentionViewKey,
} from '../../../utils/apollo/graphqlSchema';
import {
  retentionModeTooltipOption,
  retentionModeTooltips,
} from '../../KubitTooltip/globalTooltips';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../redux/selectors/builder';
import { assertCondition } from '../../../utils/types';
import BuilderEnumSelect from './BuilderEnumSelect';

export default () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(
    defaultOptions?.type === QueryType.Retention &&
      selectedOptions?.type === QueryType.Retention,
  );

  const selectedRetentionView = selectedOptions.retentionView;

  const menuOptions = defaultOptions.retentionViews.map((rv) => ({
    ...rv,
    tooltip: retentionModeTooltips[rv.key],
  }));

  const handleChange = useCallback(
    (value: RetentionViewKey) => {
      dispatch(
        setRetentionViewAction({
          retentionViewKey: value,
        }),
      );
    },
    [dispatch],
  );

  return (
    <BuilderEnumSelect
      label={'Mode'}
      enumOptions={menuOptions}
      selectedOption={selectedRetentionView}
      onChange={handleChange}
      tooltipOption={retentionModeTooltipOption}
    />
  );
};
